import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls window to top on every route change.
// (Floating back-to-top button removed — keeps a single floating icon.)
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
